import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box, Button, GridItem, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { getAccountingDetails } from '~/integrations/Accounting/accounting.utils';
import { useOpenMapTaxRatesModal } from '~/integrations/Accounting/MapTaxRatesModal/useOpenMapTaxRatesModal';
import { isAccountingQbo } from '~/types/api.model';
import styles from './AccountingSetupPage.module.scss';
export const GetMapTaxRatesSetupRowTID = (parentTestId)=>getTestIds(parentTestId);
export const MapTaxRatesSetupRow = (param)=>{
    let { accounting, testId } = param;
    const { t } = useLocaleKeys('integrations.accounting');
    const { MapTaxRatesSetupRowTestIds } = useMemo(()=>GetMapTaxRatesSetupRowTID(testId), [
        testId
    ]);
    const { name: accountingName } = getAccountingDetails(accounting);
    const taxIntegration = isAccountingQbo(accounting) ? 'qbo' : 'xero';
    const openMapTaxRates = useOpenMapTaxRatesModal(taxIntegration);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(GridItem, {
                span: 10,
                children: /*#__PURE__*/ _jsx(Typography, {
                    children: t.mapTaxRatesTo({
                        accountingName
                    })
                })
            }),
            /*#__PURE__*/ _jsx(GridItem, {
                span: 2,
                justify: "center",
                children: /*#__PURE__*/ _jsx(Box, {
                    as: "span",
                    testId: MapTaxRatesSetupRowTestIds.Root(),
                    children: /*#__PURE__*/ _jsx(Button, {
                        bi: {
                            name: 'integrations_map_tax_rates_open'
                        },
                        className: styles.button,
                        testId: MapTaxRatesSetupRowTestIds.Button(),
                        onClick: openMapTaxRates,
                        children: t.mapTaxRatesButton()
                    })
                })
            })
        ]
    });
};
